"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useFalcor: true,
  FalcorConsumer: true,
  FalcorProvider: true,
  avlFalcor: true
};
exports.avlFalcor = exports.FalcorProvider = exports.FalcorConsumer = exports.useFalcor = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _falcorGraph = require("./falcorGraph");

Object.keys(_falcorGraph).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _falcorGraph[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _falcorGraph[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FalcorContext = /*#__PURE__*/_react["default"].createContext();

var useFalcor = function useFalcor() {
  return _react["default"].useContext(FalcorContext);
};

exports.useFalcor = useFalcor;
var FalcorConsumer = FalcorContext.Consumer;
exports.FalcorConsumer = FalcorConsumer;

var FalcorProvider = function FalcorProvider(_ref) {
  var falcor = _ref.falcor,
      children = _ref.children;

  var _React$useState = _react["default"].useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      falcorCache = _React$useState2[0],
      setFalcorCache = _React$useState2[1];

  var updateCache = _react["default"].useMemo(function () {
    return (0, _lodash["default"])(function () {
      var cache = falcor.getCache();
      setFalcorCache(cache);
    }, 250);
  }, [falcor]);

  _react["default"].useEffect(function () {
    falcor.onChange(updateCache);
    return function () {
      falcor.remove(updateCache);
    };
  }, [falcor, updateCache]);

  var falcorValue = _react["default"].useMemo(function () {
    return {
      falcor: falcor,
      falcorCache: falcorCache
    };
  }, [falcor, falcorCache]);

  return /*#__PURE__*/_react["default"].createElement(FalcorContext.Provider, {
    value: falcorValue
  }, children);
};

exports.FalcorProvider = FalcorProvider;

var noMap = function noMap() {
  return {};
};

var avlFalcor = function avlFalcor(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$mapCacheToPr = options.mapCacheToProps,
      mapCacheToProps = _options$mapCacheToPr === void 0 ? noMap : _options$mapCacheToPr;
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(FalcorContext.Consumer, null, function (falcor) {
      return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, falcor, mapCacheToProps(falcor.falcorCache, props)));
    });
  };
};

exports.avlFalcor = avlFalcor;